var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 48,
    viewBox: "0 0 164 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#545496"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 4,
    height: 33,
    rx: 2,
    fill: "#545496"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13,
    width: 4,
    height: 21,
    rx: 2,
    fill: "#545496"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 13,
    width: 4,
    height: 23,
    rx: 2,
    fill: "#545496"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 9,
    width: 4,
    height: 31,
    rx: 2,
    fill: "#545496"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 6,
    width: 4,
    height: 36,
    rx: 2,
    fill: "#545496"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 4,
    height: 28,
    rx: 2,
    fill: "#545496"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 10,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#545496"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 13,
    width: 4,
    height: 23,
    rx: 2,
    fill: "#545496"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 13,
    width: 4,
    height: 23,
    rx: 2,
    fill: "#545496"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 16,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#545496"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 8,
    width: 4,
    height: 34,
    rx: 2,
    fill: "#545496"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 10,
    width: 4,
    height: 29,
    rx: 2,
    fill: "#545496"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 8,
    width: 4,
    height: 33,
    rx: 2,
    fill: "#545496"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 11,
    width: 4,
    height: 25,
    rx: 2,
    fill: "#545496"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 10,
    width: 4,
    height: 30,
    rx: 2,
    fill: "#545496"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    width: 4,
    height: 48,
    rx: 2,
    fill: "#F2F3F7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 6,
    width: 4,
    height: 35,
    rx: 2,
    fill: "#545496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderImage);
export default __webpack_public_path__ + "static/media/orderImage.fdcd80b1cee68ae08334e36d029a8aba.svg";
export { ForwardRef as ReactComponent };